import { render, staticRenderFns } from "./CategoryRight.vue?vue&type=template&id=f4e7c7c6&scoped=true&"
import script from "./CategoryRight.vue?vue&type=script&lang=js&"
export * from "./CategoryRight.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRight.vue?vue&type=style&index=0&id=f4e7c7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e7c7c6",
  null
  
)

export default component.exports